// extracted by mini-css-extract-plugin
module.exports = {"taskCard":"TaskCard_taskCard__PxS-M"};